export default {
  data () {
    return {
      loading: false,
      messageList: null,
      loadingMore: false,
      noMore: true,
      loadingLeast: false
    }
  },
  methods: {
    loadMessage () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.queryMessage().then(response => {
        if (response.data) {
          this.messageList = response.data['messageList'] || []
          this.noMore = response.data['noMore']
          this.handleLoadMoreEvent()
        }
      }, () => {
        this.$message.error('请求消息数据失败')
      }).finally(() => {
        this.loading = false
      })
    },
    loadMoreMessage () {
      if (this.loadingMore) {
        return
      }
      this.loadingMore = true
      this.queryMessage().then(response => {
        if (response.data) {
          let messageList = response.data['messageList']
          if (messageList && messageList.length) {
            this.messageList = this.messageList.concat(messageList)
          }
          this.noMore = response.data['noMore']
          this.handleLoadMoreEvent()
        }
      }, () => {
        this.$message.error('请求消息数据失败')
      }).finally(() => {
        this.loadingMore = false
      })
    },
    loadLeastMessage () {
      if (this.messageList) {
        if (this.messageList.length) {
          if (this.loadingLeast) {
            return
          }
          let fromId = this.messageList[0].id
          this.loadingLeast = true
          this.$ajax({
            url: '/support/message/biz/notification/least',
            method: 'post',
            data: this.$qs.stringify({
              fromId: fromId || ''
            })
          }).then(response => {
            if (response.data) {
              let messageList = response.data['messageList']
              if (messageList && messageList.length) {
                this.messageList = messageList.concat(this.messageList)
              }
            }
          }).finally(() => {
            this.loadingLeast = false
          })
        } else {
          this.loadMoreMessage()
        }
      }
    },
    handleLoadMoreEvent () {
      if (this.visible) {
        this.$nextTick(() => this.$emit('loadMoreEvent'))
      }
    }
  }
}
